import { Typography, Box, Button } from '@mui/material'
import { Modal } from '../../Components/Modal'
import { useState } from 'react'
import { TextAreaWithLabel } from '../../Components/TextArea'
import { TextFieldWithLabel } from '../../Components/TextField'
import FilePicker from '../../Components/FilePicker'
import { toast } from 'react-toastify'

export interface EmailContentEnterProps {
  emailList: string[]
  onBack: () => void
  onSendEmails: (subject: string, body: string, attachment: File | null) => void
}

export function EmailContentEnter (props: EmailContentEnterProps): JSX.Element {
  const [showEmails, setShowEmails] = useState(false)
  const [subject, setSubject] = useState<string>('')
  const [body, setBody] = useState<string>('')
  const [attachment, setAttachment] = useState<File | null>(null)

  const modalContent = <>
    <Typography variant='body1'>Emails will be sent to these {props.emailList.length } email addresses:</Typography>
    <ul> {
      props.emailList.map((email, index) => {
        return <li>{email}</li>
      })
    }
    </ul >
  </>

  const sendEmails = async (): Promise<void> => {
    if (subject === '') {
      toast.error('Please enter a subject.')
    } else if (body === '') {
      toast.error('Please enter a body.')
    } else {
      props.onSendEmails(subject, body, attachment)
    }
  }

  return <>
    {props.emailList.length === 0 && <Typography variant='h6' data-testid='noEmailsMessage'>No email addresses found for the selected criteria.</Typography>}
    {props.emailList.length !== 0 &&
      <Box className='mt-10'>
        <Button color='secondary' variant='contained' onClick={() => { setShowEmails(true) }} data-testID='viewEmails'>View Emails ({props.emailList.length})</Button>
        <TextFieldWithLabel
          label='Subject'
          data-testid='subject'
          name='subject'
          value={subject}
          onChange={(e) => { setSubject(e.target.value) }}
        />
        <TextAreaWithLabel
          label='Body'
          name='body'
          onChange={(e) => { setBody(e.target.value) }}
          value={body}
        />
        <Box className='mt-10'>
          <FilePicker
            label='Attachment'
            name='attachment'
            onSelect={(e: any) => {
              setAttachment(e.target.files[0])
            }}
          />
          <span className='ml-10'>{attachment?.name}</span>
        </Box>
        <Modal
          open={showEmails}
          title='Caregiver Emails'
          hideCancelButton={true}
          confirmButtonText='Close'
          onConfirm={() => { setShowEmails(false) }}
          onClose={() => { setShowEmails(false) }}
          confirmationContent={modalContent}
        />
      </Box>
    }
    <Box className='mt-10'>
      <Button color='secondary' variant='contained' onClick={props.onBack} data-testID='emailBackButton'>Back</Button>
      <Button color='secondary' variant='contained' className='ml-10' onClick={sendEmails} disabled={props.emailList.length === 0}>Send Emails</Button>
    </Box>
  </>
}
